import { useState, useEffect } from 'react';
import { Box, FormControl, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';

const mesesDelAnio = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const TmonFilterOptions = ({ varState, setVarState }) => {
    const [selectedMonths, setSelectedMonths] = useState([]);

    useEffect(() => {
        if (varState?.a?.m) {
            setSelectedMonths(mergeData(varState?.a?.m))
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setVarState({
            ...varState,
            a: formatMonth(selectedMonths)
        })
        // eslint-disable-next-line
    }, [selectedMonths])

    const mergeData = (numbers) => {
        const monthNames = {
            1: "Enero", 2: "Febrero", 3: "Marzo", 4: "Abril", 5: "Mayo", 6: "Junio",
            7: "Julio", 8: "Agosto", 9: "Septiembre", 10: "Octubre", 11: "Noviembre", 12: "Diciembre"
        };
        let result = [];
        let ranges = numbers?.split(',');
        ranges?.forEach(range => {
            if (range.includes('-')) {
                let [start, end] = range.split('-').map(Number);
                for (let i = start; i <= end; i++) {
                    result.push(monthNames[i]);
                }
            } else {
                result.push(monthNames[Number(range)]);
            }
        });
        return result;
    }

    function formatMonth(months) {
        const monthNumbers = {
            "Enero": 1, "Febrero": 2, "Marzo": 3, "Abril": 4, "Mayo": 5, "Junio": 6,
            "Julio": 7, "Agosto": 8, "Septiembre": 9, "Octubre": 10, "Noviembre": 11, "Diciembre": 12
        };
        // Convertir nombres de meses a números y ordenarlos
        let numbers = months.map(month => monthNumbers[month]).sort((a, b) => a - b);
        // Agrupar números consecutivos
        let result = [];
        let start = numbers[0];
        for (let i = 1; i < numbers.length; i++) {
            if (numbers[i] !== numbers[i - 1] + 1) {
                result.push(start === numbers[i - 1] ? `${start}` : `${start}-${numbers[i - 1]}`);
                start = numbers[i];
            }
        }
        result.push(start === numbers[numbers.length - 1] ? `${start}` : `${start}-${numbers[numbers.length - 1]}`);
        return { m: `${result.join(',')}` }
    }

    const handleMonthChange = (month) => {
        setSelectedMonths(prev =>
            prev.includes(month) ? prev.filter(m => m !== month) : [...prev, month]
        );
    };

    return (
        <Box>
            <Box width={'80%'} mt={2}>
                <FormControl component="fieldset">
                    <FormGroup style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                        {mesesDelAnio.map((month) => (
                            <FormControlLabel
                                key={month}
                                control={
                                    <Checkbox
                                        checked={selectedMonths.includes(month)}
                                        onChange={() => handleMonthChange(month)}
                                        color="primary"
                                    />
                                }
                                label={month}
                            />
                        ))}
                    </FormGroup>
                </FormControl>
            </Box>
        </Box>
    );
}

export default TmonFilterOptions;





